module.exports = __webpack_public_path__ + "static/media/vi.2127440f.svg";